'use client'

import * as React from 'react'
import { Section } from '../layout/Section'
import { Container } from '../layout/Container'
import { FadeIn } from '../motion/FadeIn'

interface ContactPageProps {
  heading?: string
  subheading?: string
  email: string
  responseTime?: string
  icon?: React.ReactNode
}

export function ContactPage({
  heading = 'Contact Us',
  subheading = 'Have questions, feedback, or need enterprise support? We\'d love to hear from you.',
  email,
  responseTime = 'We typically respond within 24 hours.',
  icon,
}: ContactPageProps) {
  return (
    <Section className="min-h-[60vh]">
      <Container size="sm">
        <div className="text-center">
          {icon && (
            <FadeIn>
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[var(--accent)]/10 mb-6">
                {icon}
              </div>
            </FadeIn>
          )}
          <FadeIn delay={0.1}>
            <h1 className="headline-lg mb-4">{heading}</h1>
          </FadeIn>
          <FadeIn delay={0.2}>
            <p className="body-lg mb-8 max-w-xl mx-auto">{subheading}</p>
          </FadeIn>
          <FadeIn delay={0.3}>
            <a
              href={`mailto:${email}`}
              className="inline-flex items-center gap-2 px-6 py-3 bg-[var(--accent)] text-white font-medium rounded-lg hover:opacity-90 transition-opacity"
            >
              {email}
            </a>
          </FadeIn>
          {responseTime && (
            <FadeIn delay={0.4}>
              <p className="mt-8 text-sm text-[var(--landing-text-tertiary)]">
                {responseTime}
              </p>
            </FadeIn>
          )}
        </div>
      </Container>
    </Section>
  )
}
